class CategoriaProductoTraduccion
{
  idCategoriaProductoTraduccion = 0;
  nombreCategoria = null;
  categoriaProducto_idCategoriaProducto = 0;
  idiomas_idIdioma = 0;
  idioma = null;

  constructor(obj = {}) {
    Object.assign(this, obj);
  }
}

module.exports = CategoriaProductoTraduccion;
